module.exports = __webpack_public_path__ + "static/media/logistock@3x.adc10b39.png";